//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'empleado',
        value: ({ hr_employee }) =>
            `${hr_employee.names} ${hr_employee.last_name1} ${
                hr_employee.last_name2
            }`,
    },
    {
        text: 'estado',
        align: 'center',
        value: ({ hr_finiquito_status }) => hr_finiquito_status.status,
        input: {
            type: 'chip',
            props: {
                label: true,
            },
        },
    },
    // {
    //     text: 'Horas',
    //     value: 'weekly_hours',
    // },
    {
        text: 'fecha de creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
    // {
    //     text: 'Termino En',
    //
    //     value: ({end_date})=>{
    //         if(end_date){
    //             return convertFormatDate(end_date)
    //         }
    //         else{
    //             return 'Sin termino'
    //         }
    //     }
    // }
]
